import {
    CACHE_STORAGE_KEYS,
    clear_persistent_cache_data,
    get_fresh_nonce_cache_ttl_ms,
    read_persistent_cache_data,
    write_persistent_cache_data,
} from "../utils/persistent-cache";
import {getAjaxUrl, getSiteVar} from "./site-vars";

let freshNonce = null;
let noncePromise = null;
let freshNonceCacheHydrated = false;

const hydrateFreshNonceCache = () => {
    if (freshNonceCacheHydrated) return;
    freshNonceCacheHydrated = true;

    const cachedNonce = read_persistent_cache_data(CACHE_STORAGE_KEYS.freshNonce);
    if (cachedNonce === null) return;

    if (typeof cachedNonce === 'string' && cachedNonce.length) {
        freshNonce = cachedNonce;
        return;
    }

    clear_persistent_cache_data(CACHE_STORAGE_KEYS.freshNonce);
};

const clearFreshNonceCache = () => {
    freshNonce = null;
    clear_persistent_cache_data(CACHE_STORAGE_KEYS.freshNonce);
};

const getNonce = () => {
    hydrateFreshNonceCache();
    return freshNonce || getSiteVar('nonce');
};

const isAuthOrPermissionFailure = (err) => {
    if (!err || !err.xhr) return false;
    return err.xhr.status === 401 || err.xhr.status === 403;
};

const isWpAjaxNonceFailure = (err) => {
    if (!err || !err.xhr) return false;
    if (err.xhr.status !== 403) return false;

    const body = (typeof err.xhr.responseText === 'string') ? err.xhr.responseText.trim() : '';
    return body === '-1';
};

const fetchFreshNonce = (forceRefresh = false) => {
    hydrateFreshNonceCache();
    if (forceRefresh) {
        clearFreshNonceCache();
    }

    if (freshNonce) {
        return Promise.resolve(freshNonce);
    }

    if (noncePromise) {
        return noncePromise;
    }

    noncePromise = new Promise((resolve) => {
        $.ajax({
            url: getAjaxUrl(),
            type: 'POST',
            data: {
                action: 'get_fresh_nonce'
            },
            success(response) {
                if (response.success && response.data && response.data.nonce) {
                    freshNonce = response.data.nonce;
                    write_persistent_cache_data(CACHE_STORAGE_KEYS.freshNonce, freshNonce, get_fresh_nonce_cache_ttl_ms());
                    noncePromise = null;
                    resolve(freshNonce);
                    return;
                }

                noncePromise = null;
                resolve(getSiteVar('nonce'));
            },
            error() {
                noncePromise = null;
                resolve(getSiteVar('nonce'));
            }
        });
    });

    return noncePromise;
};

export {
    clearFreshNonceCache,
    fetchFreshNonce,
    getNonce,
    isAuthOrPermissionFailure,
    isWpAjaxNonceFailure,
};
